import { ApplicationEnums, GeneralEnumsApi } from 'api/general-enums';
import { EnumsModelDTO, SystemsClient } from "api/swagger/ApiClient";
import { autoinject } from "aurelia-framework";

@autoinject
export class GeneralEnumsClientApi implements GeneralEnumsApi {
  constructor(private systemsClient: SystemsClient) {
  }

  async getApplicationEnums(): Promise<ApplicationEnums> {
    return this.mapToApplicationEnums(await this.systemsClient.getEnums());
  }

  private mapToApplicationEnums(dto: EnumsModelDTO): ApplicationEnums {
    return {
      approvalStatuses: dto.approvalStatuses,
      approvalTypes: dto.approveTypes,
      approvalRequirements: dto.approvalRequirements,
      airlineRatings: dto.airlineRatings,
      airlineStatuses: dto.airlineStatuses,
      classesOfTravel: dto.classesOfTravel,
      deviationTypes: dto.deviationTypes,
      deviationWorkflowTypes: dto.deviationWorkflowTypes,
      deviationDetailTypes: dto.deviationDetailTypes,
      deviationRequestStatuses: dto.deviationRequestStatuses,
      flightTimes: dto.flightTimes,
      locationCurrentnessStatuses: dto.locationCurrentnessStatuses,
      transportDataTypes: dto.transportationSystemTypes
    };
  }
}
